(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-list"] && !Shopify.designMode) return;
  try {
    // main header nav items
  document.querySelectorAll('nav > ul.list-menu:not(.header__submenu) > li > a.header__menu-item').forEach(headerLink => headerLink.addEventListener('click', (e) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'header_menu',
      'header_category': e.currentTarget.dataset.category ? e.currentTarget.dataset.category.trim() : e.currentTarget.dataset.category
    });
  }))

  // submenu items
  document.querySelectorAll('ul.header__submenu li a.header__menu-item').forEach(headerLink => headerLink.addEventListener('click', (e) => {
    const linkEl = e.currentTarget || (e.target && e.target.closest && e.target.closest('a.header__menu-item'));
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'header_menu',
      'header_category': linkEl && linkEl.dataset.parentCategory ? linkEl.dataset.parentCategory.trim() : linkEl && linkEl.dataset.parentCategory,
      'header_subcategory': linkEl && linkEl.dataset.subcategory ? linkEl.dataset.subcategory.trim() : linkEl && linkEl.dataset.subcategory
    });
  }))
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    document.addEventListener("readystatechange", (e) => {
    if(document.readyState === "complete") {

      //Return if global is set to off
      if(window.Resources.showSalesBadge == "false") return;

      //Get current template via <body> class
      const body = document.querySelector("body");
      const substring = "pagetype";

      const matchingClass = Array.from(body.classList).find(cls => cls.includes(substring));
      const split = matchingClass.split("__");
      const template = split[1];

      if(template == "product") {

        //Check if dynamic sales is enabled
        const salesBadge = document.querySelector(".price--on-sale:not(.price__custom-sales-badge)");

        //If not, return
        if(!salesBadge) return;

        salesBadgePDP(salesBadge, null);

        //Listen to variant change event
        //Rerun sales badge logic
        document.addEventListener("change", (event) => {
          if(event.target.matches("input#hiddenVariantId")) {

            const variantId = Number(new URLSearchParams(window.location.search).get("variant"));

            //Safety buffer to ensure everything has had time to update
            setTimeout(() => {
              salesBadgePDP(salesBadge, variantId);
            }, 100);
          }
        });
      }
      else if(template == "collection") {
        const saleClasses = document.querySelectorAll(".price--on-sale:not(.price__custom-sales-badge)");

        salesBadgePLP(saleClasses, null);
      }
    }

    function salesBadgePDP(priceElement, variantId) {

      const productHandle = priceElement.dataset.productHandle;

      //Run call to product json url to fetch data
      getSalePrice(productHandle, variantId)
        .then((data) => {

          if(data.onSale != true) return;

          //If we have data, run display badge function
          displaySalesBadge(data, document);

        }).catch((err) => console.error(err));
    }

    function displaySalesBadge(data, element) {

      //Run math function
      const finalNumber = calculateAndFormatSavings(data.price, data.compareAtPrice);

      const salesBadge = element.querySelector(".price__sale-badge");

      if(!salesBadge) return;

      //Display badge, fade in animation class
      salesBadge.innerHTML += finalNumber;
      salesBadge.classList.add("inview");
    }

    function salesBadgePLP(priceElements) {

      if(priceElements.length <= 0) return;

      //Loop through each product card
      priceElements.forEach((element) => {
        const productHandle = element.dataset.productHandle;

        getSalePrice(productHandle)
        .then((data) => {

          if(data.onSale != true) return;

          displaySalesBadge(data, element);

        }).catch((err) => console.error(err));
      });
    }

    //Calculate savings, format with decimals, add closing parenthesis
    function calculateAndFormatSavings(salePrice, fullPrice) {
      
      const difference = fullPrice - salePrice;
      const decimaled = Number(difference.toFixed(2));

      let finalNumber = 0;

      if (Number.isInteger(decimaled)) {
        return `${decimaled})`;
      }
      
      return `${decimaled.toFixed(2)})`;
    }

    //Function to get price data from product URL .json
    async function getSalePrice(handle, variantId = null) {

      const res = await fetch(`/products/${handle}.json`);

      if(!res.ok) throw new Error(`HTTP ${res.status}`);

      const { product } = await res.json();

      const variant = variantId
        ? product.variants.find((v) => v.id === variantId)
        : product.variants[0];

      if(!variant) throw new Error("Variant not found.");

      //Format strings
      const price = parseFloat(variant.price);
      const compareAt = variant.compare_at_price
        ? parseFloat(variant.compare_at_price)
        : null;

      const onSale = compareAt != null && compareAt > price;

      //Return product data we need
      return {
        variantId: variant.id,
        price,
        compareAtPrice: compareAt,
        onSale
      };
    }
  });
  } catch(e) { console.error(e); }
})();

})();
